var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "annonce-delete-modal-in-progress",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("Ok"),
        centered: "",
        "hide-header": "",
        "ok-variant": "primary"
      },
      on: { cancel: _vm.hideModal, close: _vm.hideModal, ok: _vm.handleOk }
    },
    [
      _c("div", { staticClass: "delete-container" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center mb-4"
          },
          [
            _c("span", { staticClass: "page-title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("annonce.already.askedToBeDeleted.title")) +
                  " "
              )
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "ph-custom ph-x-bold cursor",
              on: { click: _vm.hideModal }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("annonce.already.askedToBeDeleted.message")) +
              "\n    "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-515b2bac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515b2bac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceDeleteModalInProgress.vue
// module id = T/Wr
// module chunks = 0